import { Col, Row } from 'antd';
import { Button } from '../../../../design-system';
import { LiaoChart, ParameterLimits } from './components';
import { useLiaoAnalysis } from './hooks';

type LiaoAnalysisProps = {
  show: boolean;
  showLambda: boolean;
};

export function LiaoAnalysis({ show, showLambda }: LiaoAnalysisProps) {
  const {
    isLocalCalculated,
    loading,
    customValues,
    chartData,
    isCalculateLiaoAnalysisDisabled,
    numberOfPoints,
    setNumberOfPoints,
    resetSample,
    applyCustomLiao,
    calculateLiao,
    findBestValues
  } = useLiaoAnalysis();

  if (!show) return null;

  return chartData.calculated.length ? (
    <div style={{ marginTop: '1rem' }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={24} xl={10}>
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <ParameterLimits
              customValues={customValues}
              disabled={isCalculateLiaoAnalysisDisabled}
              calculateLiao={calculateLiao}
            />
            <div
              style={{
                marginTop: '0.75rem',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '8px',
                width: '100%',
                maxWidth: 'max-content',
              }}
            >
              {isLocalCalculated && (
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={resetSample}
                  disabled={loading.bestValues || loading.custom}
                >
                  Reset changes
                </Button>
              )}
              <Button
                variant="secondary"
                size="sm"
                onClick={findBestValues}
                loading={loading.bestValues}
                disabled={loading.custom}
              >
                Find best values
              </Button>
              <Button
                variant="primary"
                size="sm"
                onClick={applyCustomLiao}
                loading={loading.custom}
                disabled={loading.bestValues}
              >
                Save
              </Button>
            </div>
          </div>
        </Col>
        <Col xs={24} md={24} xl={14}>
          <LiaoChart
            chartData={chartData}
            showLambda={showLambda}
            numberOfPoints={numberOfPoints}
            setNumberOfPoints={setNumberOfPoints}
          />
        </Col>
      </Row>
    </div>
  ) : (
    <div className="no-data-div" style={{ marginTop: '1rem' }}>
      No Liao curve data computed. Check <strong>Pc Variables</strong> for missing or invalid values and try recalculating.
    </div>
  );
}
